import type { ApplicationFormData } from "../types/applicationTypes";

/**
 * Serialize the current value of a dirty field path for pause/unpause comparison.
 */
export function getFieldValueSnapshot(
  data: ApplicationFormData,
  fieldPath: string,
): string {
  if (fieldPath === "home") return JSON.stringify(data.home);
  if (fieldPath === "land") return JSON.stringify(data.land);
  if (fieldPath === "pricing") return JSON.stringify(data.pricing);
  if (fieldPath === "lenders") return JSON.stringify(data.lenders);
  if (fieldPath === "hasCoBorrower") return String(data.hasCoBorrower);

  const parts = fieldPath.split(".");
  if (parts[0] === "primaryBorrower" || parts[0] === "coBorrower") {
    let value: unknown =
      parts[0] === "primaryBorrower" ? data.primaryBorrower : data.coBorrower;
    for (let i = 1; i < parts.length; i++) {
      if (value == null) return "";
      const key = parts[i];
      if (/^\d+$/.test(key)) {
        value = (value as unknown[])[parseInt(key, 10)];
      } else {
        value = (value as Record<string, unknown>)[key];
      }
    }
    return JSON.stringify(value ?? "");
  }

  return "";
}
